import { CustomFieldClassType } from '@cims-online/shared'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import DesignSubmittalLogTable from './components/DesignSubmittalLogTable'
import { DesignSubmittalLogProvider } from './DesignSubmittalLogContext'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { WithPayItemGlobalId } from 'components/CIMSTable/components/HeaderActionButtons/types'

const DesignSubmittalLog: React.VFC<WithPayItemGlobalId> = ({
  payItemGlobalId,
}) => {
  return (
    <ProjectCustomFieldsProvider
      classType={CustomFieldClassType.DesignSubmittal}
    >
      <PayItemSelectProvider>
        <DesignSubmittalLogProvider payItemGlobalId={payItemGlobalId}>
          <DesignSubmittalLogTable />
        </DesignSubmittalLogProvider>
      </PayItemSelectProvider>
    </ProjectCustomFieldsProvider>
  )
}

export default DesignSubmittalLog
